var _defs, _rect, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallDecor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 320",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wd-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FBF5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5EAD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wd-ray",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDB65C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8C6C1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wd-mirror",
    cx: "40%",
    cy: "35%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F3FAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#CFE8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9EC9C5"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 320,
    fill: "url(#wd-bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200,165)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#wd-ray)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -125 L10 -80 L-10 -80 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 -118 L48 -72 L28 -80 Z",
    transform: "rotate(20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 -118 L48 -72 L28 -80 Z",
    transform: "rotate(-20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 -118 L48 -72 L28 -80 Z",
    transform: "rotate(40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 -118 L48 -72 L28 -80 Z",
    transform: "rotate(-40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 -118 L48 -72 L28 -80 Z",
    transform: "rotate(60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 -118 L48 -72 L28 -80 Z",
    transform: "rotate(-60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 -118 L48 -72 L28 -80 Z",
    transform: "rotate(80)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 -118 L48 -72 L28 -80 Z",
    transform: "rotate(-80)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 -118 L48 -72 L28 -80 Z",
    transform: "rotate(100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 -118 L48 -72 L28 -80 Z",
    transform: "rotate(-100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 -118 L48 -72 L28 -80 Z",
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 -118 L48 -72 L28 -80 Z",
    transform: "rotate(-120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 -118 L48 -72 L28 -80 Z",
    transform: "rotate(140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 -118 L48 -72 L28 -80 Z",
    transform: "rotate(-140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 -118 L48 -72 L28 -80 Z",
    transform: "rotate(160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 -118 L48 -72 L28 -80 Z",
    transform: "rotate(-160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -125 L10 -80 L-10 -80 Z",
    transform: "rotate(180)"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 55,
    fill: "url(#wd-mirror)",
    stroke: "#C9A227",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25 -25 Q-10 5 -20 40",
    stroke: "#ffffff",
    strokeWidth: 6,
    opacity: 0.5,
    fill: "none",
    strokeLinecap: "round"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 300,
    textAnchor: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 14,
    fill: "#4E3F37",
    letterSpacing: 1
  }, "Decorative Wall Art")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallDecor);
export default __webpack_public_path__ + "static/media/wall-decor.8ea74acfe97bd2aa28f3ae4cb531ab5b.svg";
export { ForwardRef as ReactComponent };